import {
  Box,
  HStack,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

interface MultipleChoiceProps {
  question: string;
  choices: string[];
  selectedIndex?: number;
  onSelect: (selectedAnswer: number) => void;
}

export const MultipleChoice: React.FC<MultipleChoiceProps> = ({
  question,
  choices,
  selectedIndex,
  onSelect,
}) => {
  const border = useColorModeValue('gray.200', 'gray.600');
  const selectedBg = useColorModeValue('blue.50', 'blue.900');
  const selectedBorder = useColorModeValue('blue.600', 'blue.300');
  const muted = useColorModeValue('gray.600', 'gray.300');

  return (
    <RadioGroup
      aria-label={question}
      value={selectedIndex === undefined ? '' : String(selectedIndex)}
      onChange={(value) => onSelect(Number(value))}
    >
      <Stack spacing={1.5}>
        {choices.map((choice, index) => {
          const selected = selectedIndex === index;
          return (
            <Box
              key={index}
              borderWidth="1px"
              borderColor={selected ? selectedBorder : border}
              bg={selected ? selectedBg : 'transparent'}
              borderRadius="lg"
              _focusWithin={{
                outline: '2px solid',
                outlineColor: selectedBorder,
                outlineOffset: '2px',
              }}
              _hover={{ borderColor: selectedBorder }}
            >
              <Radio
                value={String(index)}
                colorScheme="blue"
                display="flex"
                w="full"
                minH="44px"
                px={3}
                py={2}
                alignItems="flex-start"
                sx={{
                  '.chakra-radio__label': {
                    width: '100%',
                    marginInlineStart: '8px',
                  },
                  '.chakra-radio__control': { marginTop: '3px' },
                }}
              >
                <HStack align="start" spacing={2}>
                  <Text
                    as="span"
                    color={muted}
                    fontSize="sm"
                    lineHeight="1.5"
                    flexShrink={0}
                  >
                    {String.fromCharCode(65 + index)}.
                  </Text>
                  <Text
                    as="span"
                    fontSize="md"
                    lineHeight="1.4"
                    whiteSpace="pre-wrap"
                    overflowWrap="anywhere"
                    userSelect="text"
                    fontWeight={selected ? 'semibold' : 'normal'}
                  >
                    {choice}
                  </Text>
                </HStack>
              </Radio>
            </Box>
          );
        })}
      </Stack>
    </RadioGroup>
  );
};
